import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  FETCH_DETAILS_FAILURE,
  FETCH_DETAILS_REQUEST,
  FETCH_DETAILS_SUCCESS,
  DetailsActionType,
} from '../types/detailsType';
import { Details } from 'src/types/model';

export const fetchDetailsRequest = (): DetailsActionType => ({
  type: FETCH_DETAILS_REQUEST,
});

export const fetchDetailsSuccess = (data: Details[]): DetailsActionType => ({
  type: FETCH_DETAILS_SUCCESS,
  payload: data,
});

export const fetchDetailsFailure = (error: string): DetailsActionType => ({
  type: FETCH_DETAILS_FAILURE,
  payload: error,
});

export const fetchDetails = () => {
  return async (dispatch: Dispatch<DetailsActionType>) => {
    dispatch(fetchDetailsRequest());
    try {
      const request = await Service.get('/settings/secondary');
      const data: Details[] = await request?.data?.settings;
      // localStorage.setItem('details', JSON.stringify(data));
      dispatch(fetchDetailsSuccess(data));
    } catch (error: any) {
      dispatch(fetchDetailsFailure(error?.response?.data?.message));
      throw new Error('Failed to fetch customer');
    }
  };
};
